import { render, staticRenderFns } from "./SingleFactorView.vue?vue&type=template&id=64528706&scoped=true"
import script from "./SingleFactorView.vue?vue&type=script&lang=js"
export * from "./SingleFactorView.vue?vue&type=script&lang=js"
import style0 from "./SingleFactorView.vue?vue&type=style&index=0&id=64528706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64528706",
  null
  
)

export default component.exports